<app-card-table
    #personAddressTable
    tableKey="personAddresses"
    translatePrefix="person.address."
    [tableTitle]="'person.address.labelMulti'"
    [items]="addresses"
    [gridData]="addresses?.length ? undefined : store.data.getPersonAddresses()"
    [columns]="columns"
    [hideCheckboxes]="true"
    [additionalFilter]="additionalFilter()"
    [refreshCallback]="store.api.getPersonAddresses"
    (createCallback)="addressDetail()"
    (detailCallback)="addressDetail($event)"
    (deleteCallbackWithEvent)="deleteAddress($event)"
    [showDetail]="!!personId() && canEdit()"
    [showDelete]="canEdit()"
    [showCreate]="canEdit()"
>
    <ng-template pTemplate="type" let-data="data">
        {{ 'person.address.addressType.' + data | translate }}
    </ng-template>
</app-card-table>
